// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JzDPd","copy":"styles_copy__gKAYb","copyNoMargin":"styles_copyNoMargin__JsVH4","processing":"styles_processing__OkObm"};